import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { AccountUserService } from 'src/app/service/account.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})

export class NotificationConfigService {

    user;

    constructor(private http: HttpClient,
        private accountUserService: AccountUserService){
            this.accountUserService.user.subscribe(x => this.user = x);
        }

    fetchNotificationData(userId,organizationId){
        return this.http.get<any>(`${environment.notificationUrl2}Notification/UserSubscriptions/${userId}/${organizationId}`)
        .toPromise()
        .then(res => res);
    }
    updateNotificationData(updateData){
        return this.http.post<any>(`${environment.notificationUrl2}Notification/UserSubscriptions`, updateData)
        .toPromise()
        .then((res) => res);
    }
    getModuleChannels(){
        return this.http.get<any>(`${environment.notificationUrl2}Notification/ModuleChannels`)
        .toPromise()
        .then(res => res);
    }

}